import React from 'react';
import SvgIcon, {SvgIconProps} from '@material-ui/core/SvgIcon';

function HouseEventIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <g
        id="layer1"
        transform="translate(0,8)">
        <g
          id="g1468"
          transform="translate(0.53033008,-2.7400388)">
          <g
            id="g3084"
            transform="matrix(1.5075904,0,0,1.5075904,-5.9090749,-3.4204969)">
            <path
              opacity="0.3"
              d="M 5.3300196,4.3985456 V 14.728567 H 18.275705 V 4.4582689 l -6.579298,-5.04591776 z"
              id="path9037"
            />
            <path
              opacity="0.8"
              d="M 11.373362,-1.2714326 4.676096,3.9746612 V 4.4180205 14.728567 H 18.275705 V 4.0234893 Z m 0.01172,2.3027344 5.072266,3.8886718 V 12.908255 H 6.494457 V 4.8613799 Z"
              id="path9037-7"
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export default HouseEventIcon;

